import script from "./myCard.vue?vue&type=script&setup=true&lang=js"
export * from "./myCard.vue?vue&type=script&setup=true&lang=js"

import "./myCard.vue?vue&type=style&index=0&id=1e7140fc&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7140fc"]])

export default __exports__